import createAxiosInstance from "./createAxiosInstance";

export default createAxiosInstance("/umbraco/api/");
